import React from 'react';
import { Flex, Card, Modal, message } from 'antd';
import dayjs from 'dayjs';
import { PoweroffOutlined, MoreOutlined, LinkOutlined, EditOutlined, CopyOutlined, ToTopOutlined } from '@ant-design/icons';
import { getCurrentShopId } from '../../shop/get-current-shop';

const CardHeader = ({title}) => {
    return (
        <Flex justify="space-between">
            <div>{title}</div>
            {/* <Flex gap={10}>
                <div><ShareAltOutlined /></div>
                <div><QrcodeOutlined /></div>
                <a href="" target="_blank"><LinkOutlined /></a>
            </Flex> */}
        </Flex>
    )
}

const statusMap = {
    0: '未开始',
    1: '生效中',
    2: '已结束',
}

export default ({content}) => {
    const {couponTmpId, createTime, description, endTime, goodsIds,
        inventory, offerAmount, shopId, startTime, status, title, triggerAmount, type } = content;

    const onEndClick = async (couponTmpId) => {
    Modal.confirm({
        title: '结束优惠券',
        content: '此操作将结束此优惠券，请确认是否继续',
        okText: '确定',
        cancelText: '取消',
        onOk: async () => {
            await end(couponTmpId);
        },
    });
}

    const end =  async (couponTmpId) => {
        const res = await fetch('/api/coupon/end', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                couponTmpId,
                shopId,
            })
        })
        const result = await res.json();

        if (result?.success) {
            message.success('成功')
            setTimeout(() => {
                window.location.reload()
            }, 500)
        }else{
            message.error('失败：'+result?.data)
        }
    }

    const actions = [
        // <div><EditOutlined key="edit" /> 编辑</div>,
        // <a href={`/promotion/coupon/create?action=copy&couponTmpId=${couponTmpId}`}><CopyOutlined /> 复制</a>
    ]

    if(status === 1) actions.push(<div onClick={() => onEndClick(couponTmpId)}><PoweroffOutlined /> 结束</div>)
    actions.push(<a href={`/promotion/coupon/create?action=view&couponTmpId=${couponTmpId}`}><MoreOutlined /> 详情</a>)

    return (
        <Card title={<CardHeader title={title} />} style={{minWidth: 360, marginBottom: 10, maxWidth: 456, width: '100%'}}
            actions={actions}
        >
            <div>优惠券类型：{type === 1 ? '代金券' : '折扣券'}</div>
            <div style={{color: '#999'}}>备注：{description || ''}</div>
            <div>
                优惠内容：
                <span style={{color: 'red'}}>
                    满{triggerAmount / 100}元{type===1 ? '减': '折扣'}{type===1 ? offerAmount / 100 : offerAmount}{type===1 ? '元': '%'}
                </span>
            </div>
            <div>状态：{statusMap[status]}</div>
            <div>活动时间：{dayjs(startTime).format('YYYY-MM-DD HH:mm')} ~ {endTime ? dayjs(endTime).format('YYYY-MM-DD HH:mm') : '无结束日期'}</div>
        </Card>
    )
}